var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var configTxt = require("../../../config-en.json");
import countries from '../../client/enhancementRequest/countries.json';
var mapContinentToRegion = function (continent, countryName) {
    switch (continent) {
        case 'Africa':
            return 'EMEA';
        case 'Antartica':
            return 'Other';
        case 'Asia':
            return 'APAC';
        case 'Europe':
            return 'EMEA';
        case 'UK&I':
            return 'UK&I';
        case 'North America':
            return 'North America';
        // return 'NA';
        case 'Oceania':
            return 'APAC';
        case 'South America':
            return 'Latin America';
        // return 'SpLatAm'
        default:
            return 'Other';
    }
};
export var removeL1FromShortDecription = function (desc) {
    var regex = /[lL]{1}[0-9][_]/;
    return desc === null || desc === void 0 ? void 0 : desc.replace(regex, '');
};
export var removeSpaceFromText = function (desc) {
    var regex = /\s+/g;
    return desc === null || desc === void 0 ? void 0 : desc.replace(regex, '');
};
export var stringStartsWithL1 = function (desc) {
    return (desc === null || desc === void 0 ? void 0 : desc.startsWith("L1_")) || false;
};
export var numericTextOnly = function (text) {
    var regex = /^[0-9]+$/;
    return regex.test(text);
};
export var textOnly = function (text) {
    var regex = /^[A-Za-z ]+$/;
    return regex.test(text);
};
export var alphaNumericTextOnly = function (text) {
    var regex = /^[a-zA-Z0-9]*$/;
    return regex.test(text);
};
export var alphaNumericWithSpaceTextOnly = function (text) {
    var regex = /^[a-z\d\s]+$/i;
    return regex.test(text);
};
export var lowercaseAlphaNumericWithDashTextOnly = function (text) {
    var regex = /^[a-z0-9\n\r-]*$/;
    return regex.test(text);
};
export var specialCharacterAmpersandDoublequoteAndLessthanIsPresent = function (text) {
    var regex = /[&<"]/;
    return regex.test(text);
};
export var numericTextWithCommaSepratted = function (text) {
    var regex = /^[0-9.,\b]+$/;
    return regex.test(text);
};
export var validateUrlLink = function (url) {
    var urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(url);
};
export var validateDomain = function (value, regexExp) {
    if (regexExp === void 0) { regexExp = ""; }
    var regex = regexExp || /^((?![\.-])[a-zA-Z0-9-_\.]).(?![\.])[a-zA-Z0-9-_\.]+(\.[a-zA-Z0-9_]+)$/;
    if (regex.test(value)) {
        return { isError: false, errorMsg: "" };
    }
    else {
        return { isError: true, errorMsg: configTxt.DOMAIN_ERR_MSG };
    }
};
export var validateEmailId = function (value) {
    var regex = /^(?![\.])[a-zA-Z0-9._-]+(?<![.]+)@(?![\.-])[a-zA-Z0-9-_\.]+(\.[a-zA-Z0-9_]+)$/;
    return regex.test(value);
};
export var validateIpHyphenComma = function (value) {
    var regex = /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(\s*[-,]\s*(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}))*$/;
    return regex.test(value.trim());
};
export var copyToUrlClipboard = function (text, setHasCopied) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(text))];
            case 1:
                _b.sent();
                setHasCopied("Copied!");
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                setHasCopied("Failed to copy!");
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var creactingBlobDownload = function (blob, fileName) {
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url || "javascript:void(0)";
    a.download = fileName || 'output.zip';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
};
export var productDropDownData = {
    options: [
        { id: 0, name: "Select", value: "" },
        { id: 1, name: "PowerCurve Originations Advanced / Pro", value: "powercurve_originations_advanced_pro" },
        { id: 2, name: "PowerCurve Originations Essentials", value: "powercurve_originations_essentials" },
        { id: 3, name: "PowerCurve Collections Advanced / Pro", value: "powercurve_collections_advanced_pro" },
        { id: 4, name: "PowerCurve Collections Essentials", value: "powercurve_collections_essentials" },
        { id: 5, name: "PowerCurve Collections Healthcare", value: "powercurve_collections_healthcare" },
        { id: 6, name: "CrossCore", value: "crosscore" },
        { id: 7, name: "PCSM As a service", value: "pcsm_as_a_service" }
    ]
};
export var regionSponsoringPartnerDropDownData = {
    options: [
        { id: 0, name: "Global", value: "global" },
        { id: 1, name: "Brazil", value: "brazil" },
        { id: 2, name: "UK&I", value: "uk" },
        { id: 3, name: "North America", value: "north_america" },
        { id: 4, name: "EMEA", value: "emea" },
        { id: 5, name: "APAC", value: "apac" },
        { id: 6, name: "Spanish LATAM", value: "splatam" },
        // { id: 4, name: "Spanish LATAM", value: "splatam" },
        // { id: 5, name: "EMAP(others)", value: "emap" },
        // { id: 6, name: "ANZ", value: "australia" },
        // { id: 7, name: "Italy", value: "italy" },
        // { id: 8, name: "Spain", value: "spain" },
        // { id: 9, name: "DACH", value: "dach" },
        // { id: 10, name: "SA", value: "sa" },
        // { id: 11, name: "Northern Europe", value: "northerneurope" },
        // { id: 12, name: "South East Asia", value: "sea" },
        // { id: 13, name: "India", value: "india" },
    ]
};
export var intakeRejectedDropDownData = {
    options: [
        { id: 0, name: "Partner not interested", value: "partner_not_interested" },
        { id: 1, name: "Not good fit", value: "not_good_fit" },
        { id: 2, name: "Others", value: "other" },
    ]
};
export var typeOfSalesDropDownData = {
    options: [
        { id: 0, name: "Select", value: "" },
        { id: 1, name: "Batch", value: "batch" },
        { id: 2, name: "Hybrid", value: "hybrid" },
        { id: 3, name: "Online", value: "online" },
        { id: 4, name: "Gaming", value: "gaming" },
        { id: 5, name: "Marketplace", value: "marketplace" }
    ]
};
export var typeClientStsRegion = {
    options: [
        { id: 0, name: "Select", value: "" },
        { id: 1, name: "APAC", value: "APAC" },
        { id: 2, name: "IN", value: "IN" },
        { id: 3, name: "UK", value: "UK" },
        { id: 4, name: "US", value: "US" },
        { id: 5, name: "cloudSTS", value: "cloudSTS" }
    ]
};
export var typeOfStudioDropDownData = {
    options: [
        { id: 0, name: "Studio standard", value: "pcsm_studio_standard" },
        { id: 1, name: "Studio lite", value: "pcsm_studio_lite" },
        { id: 2, name: "Studio standard and lite", value: "pcsm_studio_standard_and_lite" }
    ]
};
export var testStackOptions = {
    options: [
        { id: 0, name: "Select", value: "" },
        { id: 1, name: "AU-EKS-Prod-Test", value: "au_eks_prod_test" },
        { id: 2, name: "BR-EKS-Prod-Test", value: "br_eks_prod_test" },
        { id: 3, name: "EMEA-EKS-Prod-Test", value: "emea_eks_prod_test" },
        { id: 4, name: "IN-EKS-Prod-Test", value: "in_eks_prod_test" },
        { id: 5, name: "NA-EKS-Prod-Test", value: "na_eks_prod_test" },
        { id: 6, name: "NA-EKSA-Test", value: "na_eksa_test" },
        { id: 7, name: "SA-Test-GSG", value: "sa_test_gsg" },
        { id: 8, name: "UK-EKS-Prod-Test", value: "uk_eks_prod_test" },
        { id: 9, name: "NA-EKS-West-PT", value: "na_eks_west_pt" }
    ]
};
export var stackDropDownData = {
    options: [
        { id: 0, name: "Select", value: "" },
        { id: 1, name: "NA Production", value: "NA Production" },
        { id: 2, name: "NA Production Test", value: "NA Production Test" },
        { id: 3, name: "Brazil Production", value: "Brazil Production" },
        { id: 4, name: "Brazil Production Test", value: "Brazil Production Test" },
        { id: 5, name: "UK Production", value: "UK Production" },
        { id: 6, name: "UK Production Test", value: "UK Production Test" },
        { id: 7, name: "EMEA Production", value: "EMEA Production" },
        { id: 8, name: "EMEA Production Test", value: "EMEA Production Test" },
        { id: 9, name: "Australia Production", value: "Australia Production" },
        { id: 10, name: "Australia Production Test", value: "Australia Production Test" },
        { id: 11, name: "India Production", value: "India Production" },
        { id: 12, name: "India Production Test", value: "India Production Test" }
    ]
};
export var prodStackOptions = {
    options: [
        { id: 0, name: "Select", value: "" },
        { id: 1, name: "AU-EKS-Prod-Prod", value: "au_eks_prod_prod" },
        { id: 2, name: "BR-EKS-Prod-Prod", value: "br_eks_prod_prod" },
        { id: 3, name: "BR-UCB", value: "br_ucb" },
        { id: 4, name: "EMEA-EKS-Prod-Prod", value: "emea_eks_prod_prod" },
        { id: 5, name: "EMEA-EKS-UCB", value: "emea_eks_ucb" },
        { id: 6, name: "IN-EKS-Prod-Prod", value: "in_eks_prod_prod" },
        { id: 7, name: "NA-EKS-Prod-Prod", value: "na_eks_prod_prod" },
        { id: 8, name: "NA-EKS-West-PP", value: "na_eks_west_pp" },
        { id: 9, name: "NA-EKS-UCB", value: "na_eks_ucb" },
        { id: 10, name: "NA-EKSA-Live", value: "na_eksa_live" },
        { id: 11, name: "SA-Prod-Prod", value: "sa_prod_prod" },
        { id: 12, name: "UK-EKS-West-Prod-Prod", value: "uk_eks_west_prod_prod" },
        { id: 13, name: "UK-EKS-UCB", value: "uk_eks_ucb" },
        { id: 14, name: "SIT Pre-Prod", value: "sit_pre_prod" }
    ]
};
export var allCrossCoreProducts = ["Fraud Risk", "Precise ID", "Neuro ID", "FraudNet", "Digital Risk Score", "DeviceInsight", "CrossCore-Partnerships", "CrossCore Platform", "CrossCore", "BizID", "Bank Account Verification or contains KYC", "Bank Account Verification", "KYC"];
export var customCrossCoreProductAndCountry = [
    { product: "PowerCurve Customer Acquisition", country: "Spain" },
    { product: "Insurance Data Suite", country: "Germany" },
    { product: "CreditFactory", country: "Switzerland" },
    { product: "PowerCurve Customer Acquisition", country: "Netherlands" },
    { product: "PowerCurve Customer Acquisition", country: "United Kingdom" }
];
export var connectedProducts = ["Analytics Sandbox - Extended Trade", "Ascend Analytical", "Ascend Sandbox", "Ascend: Analytics on Demand", "Experian Analytical Sandbox", "Experian Analytical Sandbox - Premier Attributes", "Experian Analytical Sandbox PXE", "Mortgage Insights Dashboard for Servicing", "Sandbox Data Add On - Property Data", "Experian Assistant for Model Risk Management"];
export var defaultChooseProductItemsUK = ["Credit Card", "Auto", "Mortgage", "Home Equity", "Personal Lending", "Small Business"];
export var defaultChoosePurposesItemsUK = ["Credit Card", "Auto", "Mortgage", "Home Equity", "Personal Lending", "Small Business"];
// export const defaultChooseSubPurposesItemsUK = ["Pre-Screen", "ITA", "Line Assignment"];
export var defaultChooseSubPurposesItemsUK = ["Delphi ML", "Delphi Gen11", "Fraud", "Custom", "Semi-Custom"];
export var defaultChoosePartnersItemsUK = ["Banking Affiliate 1", "Banking Affiliate 2", "Co-Brand 1", "Co-Brand 2"];
export var defaultChooseProductItemsEMAP = ["Auto loans", "Consumer loans", "Mortgage", "Credit Cards", "Personal loans", "Commercial loans", "Revolving credit", "Business loans", "Secured loans"];
export var commonRegions = {
    options: [
        { id: 0, name: "Select", value: "" },
        { id: 1, name: "All regions", value: "All regions" },
        { id: 2, name: "Brazil", value: "Brazil" },
        { id: 3, name: "UK&I", value: "UK&I" },
        { id: 4, name: "North America", value: "North America" },
        { id: 5, name: "EMEA & APAC", value: "EMEA & APAC" },
        { id: 6, name: "Spanish LATAM", value: "Spanish LATAM" }
    ]
};
export var AdvanceSearchRegions = {
    options: [
        { id: 0, name: "Select", value: "" },
        { id: 1, name: "All regions", value: "All regions" },
        { id: 2, name: "APAC", value: "APAC" },
        { id: 3, name: "EMEA", value: "EMEA" },
        { id: 4, name: "North America", value: "North America" },
        { id: 5, name: "Latin America", value: "Latin America" },
        { id: 6, name: "UK&I", value: "UK&I" }
    ]
};
export var setCache = function (key, value) {
    localStorage.setItem(key, value ? JSON.stringify(value) : "");
};
export var getCache = function (key) {
    var data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
};
export var getCountryCodeDetails = function (countryCode) {
    if (countryCode === void 0) { countryCode = ""; }
    var u_region = "";
    var countryData = countries[String(countryCode).toUpperCase()];
    if (countryData) {
        var mappedRegion = mapContinentToRegion(countryData === null || countryData === void 0 ? void 0 : countryData.continent_name, countryData === null || countryData === void 0 ? void 0 : countryData.continent_name);
        u_region = mappedRegion;
    }
    return u_region;
};
export var partnerOnboadingFlowTypes = [
    { name: "Select", value: "" },
    { name: "Strategic/Essential flow", value: "startegicessentialflow" },
    { name: "Proof of concept", value: "poc" },
];
export var orderGuideType = [
    {
        "name": "Trigger an AscendOps Onboarding",
        "sys_id": "ccdab065836a4210bb2d58a8beaad3f2",
        "products": [{
                "name": "Ascend Ops",
                "sys_id": "d368c8c51b9855d067de39f4464bcb5b"
            }]
    },
    {
        "name": "Trigger a PCSMaaS onboarding",
        "sys_id": "f9c68a8383e54ed4918dca70deaad359",
        "products": [{
                "name": "PowerCurve Strategy Management Essentials",
                "sys_id": "2f607b8a1b6fcd94707d39f4464bcb15"
            },
            {
                "name": "PowerCurve Strategy Management Pro",
                "sys_id": "d99248d61ba70594bb9ef6b4464bcbed"
            },
            {
                "name": "PowerCurve Strategy Management Advanced",
                "sys_id": "e5d18c121ba70594bb9ef6b4464bcb82"
            }]
    },
    {
        "name": "Request an Ascend One Starter Pack",
        "sys_id": "380926f79387f114ffaa3a7febba10ab",
        "products": [{
                "name": "PowerCurve Originations Advanced",
                "sys_id": "77a3b8331b67099043b6b8c2cd4bcbe4"
            }]
    },
    {
        "name": "Trigger a CrossCore Client Onboard",
        "sys_id": "1a274974935b39d4a387309febba1024",
        "products": [{
                "name": "CrossCore Platform",
                "sys_id": "63afae72db0cb640417e3f3ffe96194e"
            }]
    },
    {
        "name": "Trigger a PowerCurve Essentials client onboard for North America",
        "sys_id": "8cd626a6c36042109551dc1e050131e1",
        "products": [{
                "name": "PowerCurve Originations Essentials",
                "sys_id": "35b4dd501bbbfc94953d3c66464bcb1a"
            }]
    },
    {
        "name": "Request an Ascend Intelligence Services Onboarding",
        "sys_id": "7da7eeb3c35d46509551dc1e05013185",
        "products": [{
                "name": "Ascend Intelligence Services",
                "sys_id": "6bc06ab5db5bdcd8336d794039961947"
            }]
    },
    {
        "name": "Trigger a Data Hub onboarding",
        "sys_id": "cf5ea124fb8e52142aecf4e0aeefdc37",
        "products": [{
                "name": "Datahub",
                "sys_id": "bc57823a1bf545d0953d3c66464bcb1f"
            }, {
                "name": "Data Hub EMAP",
                "sys_id": "813a9e55fb9e129066c7f2d2ceefdc42"
            }]
    },
    {
        "name": "Trigger an Ascend Sandbox client onboarding",
        "sys_id": "0484953d9360fa10a387309febba10fa",
        "products": [{
                "name": "Ascend Sandbox",
                "sys_id": "2a5e6d9bdb70ef44e56afa910f961992"
            }]
    },
    {
        "name": "Trigger a generic client onboarding for connected products",
        "sys_id": "fbabb99cfb662ad02aecf4e0aeefdc29",
        "products": [{
                "name": "Experian Analytical Sandbox",
                "sys_id": "e8bfae72db0cb640417e3f3ffe961981"
            },
            {
                "name": "Ascend Sandbox",
                "sys_id": "2a5e6d9bdb70ef44e56afa910f961992"
            },
            {
                "name": "Experian Assistant for Model Risk Management",
                "sys_id": "a8a459b4c396e6d804e8dc1e0501318a"
            }]
    },
    {
        "name": "Trigger an ExperianOne Essentials client onboard",
        "sys_id": "f42815cf930e71d419347a34fbba1061",
        "products": [{
                "name": "CreditFactory",
                "sys_id": "eb2fc9cc93fda950d643bb9b7bba10ef"
            },
            {
                "name": "Insurance Data Suite",
                "sys_id": "452b908693c30a1014b73024fbba1032"
            },
            {
                "name": "PowerCurve Credito (PowerCurve Credito)",
                "sys_id": "ff5f59dbdb3110143b59fbf9f49619a9"
            },
            {
                "name": "PowerCurve Customer Acquisition",
                "sys_id": "06b1599edbf21f041471317ffe9619b3"
            },
            {
                "name": "Prequal Brasil (Prequal Brazil)",
                "sys_id": "2d4dd2d4dbfa73800c9779403996191e"
            },
            {
                "name": "PowerCurve Originations Essentials",
                "sys_id": "35b4dd501bbbfc94953d3c66464bcb1a"
            }]
    }
];
